import {useState, useEffect, useRef} from 'react';

export default function UseOnScreen({
  threshold = 0.1,
  once = true
} = {}) {
  const ref = useRef(null);
  const [isVisible,
    setIsVisible] = useState(false);

  useEffect(() => {
    const observerRef = ref.current;

    if (once && isVisible) {
      return;
    }

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);

        if (once) {
          observer.unobserve(entry.target);
        }
      }
    }, {
      root: null,
      rootMargin: '0px',
      threshold: threshold,
    });

    if (observerRef) {
      observer.observe(observerRef);
    }

    return () => {
      if (observerRef) {
        observer.unobserve(observerRef);
      }
    };
  }, [once, threshold, isVisible]);

  return [ref, isVisible];
}